import React from 'react'
import styled from 'styled-components'
import { line, radius, font, surface } from 'features/dashboard/tokens'
import { scoreColour, scoreBand } from 'features/dashboard/charts/scoreColour'

const RagGauge = ({ value, label, sublabel, target = null, provisional = false }) => {
  const has = value !== null && value !== undefined
  const v = has ? Math.max(0, Math.min(100, value)) : 0
  const tint = !has ? '#cbd5e1' : (provisional ? '#d97706' : scoreColour(value))
  const band = !has ? 'no data' : (provisional ? 'provisional' : scoreBand(value))

  return (
    <Wrap>
      <Ring style={{ background: `conic-gradient(${tint} ${v * 3.6}deg, ${'#eef0f4'} 0deg)` }}>
        <RingInner>
          <RingValue $tint={tint}>{has ? `${Math.round(value)}%` : '—'}</RingValue>
          <RingBand $tint={tint}>{band}</RingBand>
        </RingInner>
      </Ring>
      <Meta>
        <Label>{label}</Label>
        {sublabel && <Sub>{sublabel}</Sub>}
        {target !== null && has && (
          <Target $ok={value >= target}>
            Target {target}% · {value >= target ? 'on track' : `${Math.round(target - value)}pt below`}
          </Target>
        )}
      </Meta>
    </Wrap>
  )
}

export default RagGauge

const Wrap = styled.div`
  display: flex; flex-direction: column; align-items: center; gap: 12px;
  padding: 8px 0;
`

const Ring = styled.div`
  width: 128px; height: 128px;
  border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  flex: 0 0 auto;
`

const RingInner = styled.div`
  width: 96px; height: 96px;
  border-radius: 50%;
  background: ${surface.card};
  border: 1px solid ${line.base};
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px;
`

const RingValue = styled.span`
  font-family: 'FuturaPT-Light', system-ui, sans-serif;
  font-size: 30px;
  letter-spacing: -1px;
  color: ${({ $tint }) => $tint};
  line-height: 1;
`

const RingBand = styled.span`
  font-size: 9.5px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ $tint }) => $tint};
`

const Meta = styled.div`
  display: flex; flex-direction: column; align-items: center; gap: 3px; text-align: center;
`

const Label = styled.span`
  font-size: ${font.body};
  font-weight: 800;
  color: ${({ theme }) => theme.colors.haiti};
`

const Sub = styled.span`
  font-size: ${font.caption};
  color: ${({ theme }) => theme.colors.grey[800]};
`

const Target = styled.span`
  margin-top: 2px;
  font-size: ${font.caption};
  font-weight: 700;
  padding: 3px 10px;
  border-radius: ${radius.pill};
  background: ${({ $ok }) => ($ok ? '#15803d14' : '#c2410c14')};
  color: ${({ $ok }) => ($ok ? '#15803d' : '#c2410c')};
  border: 1px solid ${({ $ok }) => ($ok ? '#15803d33' : '#c2410c33')};
`
